// 사용자 적립금 API 래퍼.

import type { PointTransactionDto } from "@oo/shared";
import { api } from "@/api/client.ts";

export interface PointsView {
  balance: number;
  transactions: PointTransactionDto[];
}

// 적립금 잔액 + 내역.
export async function getPoints(): Promise<PointsView> {
  const data = await api.get<{ balance: number; transactions: PointTransactionDto[] }>("/me/points");
  return { balance: data.balance, transactions: data.transactions };
}
